import 'css-chunksrc/client/pages/projectPage/exportsPage/dailyPlanningReport/columnSelector/addColumn/styles.scss';export default {
  "input": "_input_1t08r_1",
  "listRoot": "_listRoot_1t08r_14",
  "list": "_list_1t08r_14",
  "item": "_item_1t08r_30",
  "icon": "_icon_1t08r_43",
  "name": "_name_1t08r_51"
};